module.exports = __webpack_public_path__ + "static/media/party-hat.80b0eb21.gif";